import React, { Fragment} from 'react';
import { TabbedForm, FormTab, FormDataConsumer, Edit,
    TextInput, SimpleFormIterator, required, BooleanInput, ImageInput, ImageField, NumberInput, ArrayInput,ReferenceInput ,minLength,AutocompleteArrayInput,ReferenceArrayInput} from 'react-admin';
import { SALON, WORKING_WEEK, EMPTY_WEEK, COLUMN_HAIR_SERVICE } from '../../consts/Names';
import { makeStyles, Theme } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import {SalonEditToolbar} from './SalonEditToolbar';
import { number, useInput,  } from 'ra-core';
import {WithProps} from '../utils/RecordWrappers';

const SalonTitle = (props) => <span>Salon {props.record.name}</span>;


const useStyles = makeStyles((theme: Theme) => ({
    comment: {
        maxWidth: '20em',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    tab: {
        maxWidth: '40em',
        display: 'block',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
      },
      root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
      },
      gridList: {
        width: 500,
        height: 450,
      },
      toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
 }));
const noValidate = [ ];
// const numValidate = [ number("It's not a number")];
const requiredValidate = [required(), minLength(1)];
const requiredAndNum = [required(), number("It's not a number"), ];

const OnlyTime = (props) => {
    const {source, record, labeled} = props;
    let fixedSource = source.substring(source.indexOf('.') + 1);
    const classes = useStyles();
    const {
        input: {  onChange },
        meta: { touched, error },
        isRequired
    } = useInput(props);
    return (
        <TextField
        id="time"
        label={labeled}
        type="time"
        onChange={onChange}
        error={!!(touched && error)}
        helperText={touched && error}
        required={isRequired}
        className={classes.textField}
        defaultValue={record[fixedSource]}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 300, // 5 min
        }}
      />
    )
}

const redirect = () =>{
    return `/users/`
};

const reWorkingRecord = (record) => {
    let newRecord = Object.assign({}, record);
    if(!newRecord.work_time || !newRecord.work_time.length){
        newRecord.work_time = EMPTY_WEEK;
    }
    newRecord.work_time.sort(function(a, b){return a.day - b.day;})
    newRecord.work_time.unshift(newRecord.work_time.pop());

    return newRecord;
}

export const SalonEdit = (props) => {
    const classes = useStyles();

    const optionRenderer = choice => {        
        return `${WORKING_WEEK[choice]}`};
    return(
    <Edit title={<SalonTitle/>} {...props}>        
        <WithProps callBackFunc={reWorkingRecord}>{({record,...props})=>
            <TabbedForm {...props}  record={record} redirect={redirect}  toolbar={<SalonEditToolbar className={classes.toolBar} {...props}/>}>
                <FormTab
                    label="Common"
                    contentClassName={classes.tab}>
                    <TextInput disabled label="Id" source={'salon_id'} />
                    <TextInput label={'Name'} fullWidth source={SALON.name} validate={noValidate} />
                    <TextInput label={'Address'} fullWidth source={SALON.address} validate={noValidate}/>
                </FormTab>
                <FormTab
                    label="Open days/hours"
                    contentClassName={classes.tab}>   
                    <ArrayInput source={SALON.work_time} key={SALON.work_time} label="">
                        <SimpleFormIterator disableRemove disableAdd >
                            <TextInput source="day" disabled label="Day" format={record => optionRenderer(record)}/>
                            <BooleanInput source="enabled" fullWidth label="Enabled" />
                            <FormDataConsumer>
                                {
                                    ({
                                        formData, // The whole form data
                                        scopedFormData, // The data for this item of the ArrayInput
                                        getSource, // A function to get the valid source inside an ArrayInput
                                        ...rest
                                    }) =>
                                    scopedFormData.enabled ? 
                                    (
                                        <Fragment>
                                            <OnlyTime source={getSource("startTime")} labeled="Start time" {...rest} />  
                                            <OnlyTime source={getSource("endTime")} labeled="End time"  {...rest}/> 
                                        </Fragment> 
                                    ) :(null)
                                }
                            </FormDataConsumer>
                        </SimpleFormIterator >
                    </ArrayInput>            
                </FormTab>

                <FormTab
                    label="Salon Services"
                    contentClassName={classes.tab}>
                    <ReferenceArrayInput 
                    source={SALON.services_ids} 
                    perPage={1000}
                    reference={COLUMN_HAIR_SERVICE.SOURCE} 
                    label="Hair Services">
                        <AutocompleteArrayInput optionText="name"  />
                    </ReferenceArrayInput>
                </FormTab>

                <FormTab
                    label="Images"
                    contentClassName={classes.tab}>
                    <ImageInput source={SALON.images} label="Related images" multiple={true}  accept="image/*"  placeholder={<p>Drop your image here</p>}>
                        <ImageField source="image" title="title" addLabel={false}/>   
                    </ImageInput>
                </FormTab>
            </TabbedForm>
            }            
        </WithProps>     
    </Edit>     
)}